type EventChannelCallback<T> = (data: T) => void;

/** Allows clients to register listeners which are called using trigger. */
export class EventChannel<T> {
  private listeners: EventChannelCallback<T>[];

  constructor() {
    this.listeners = [];
  }

  subscribe(callback: EventChannelCallback<T>) {
    this.listeners.push(callback);
    return this.unsubscribe.bind(this, callback);
  }

  trigger(data: T) {
    this.listeners.forEach(listener => listener(data));
  }

  teardown() {
    this.listeners = [];
  }

  unsubscribe(callback: EventChannelCallback<T>) {
    this.listeners = this.listeners.filter(listener => listener !== callback);
  }
}
